module.exports = __webpack_public_path__ + "static/media/git.78ef2285.svg";